import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.status = this.element.querySelector("[name='status']");
    this.checkboxes = this.element.querySelector("#checkboxes");
    this.suggestedCode = this.element.querySelector("[name='suggested_code']");
    this.publicNote = this.element.querySelector("[name='public_note']");

    this.editFields = [
      this.checkboxes,
      this.suggestedCode,
      this.publicNote
    ]

    this.onStatusChanged();
    this.onReasonsChanged();
  }

  onStatusChanged() {
    if (this.status.value == "edited") {
      this.editFields.forEach((field) => { field.classList.remove("hidden") });
    } else {
      this.editFields.forEach((field) => { field.classList.add("hidden") });
    }
  }

  onReasonsChanged() {
  }
}